// Vendor imports
const _ = require('lodash')
// Shared imports
const nameUtils = require('shared/name-utils')

const EXTERNAL_URL_REGEXP = /^(http(s?):)?\/\//

const SUCCESS_MESSAGES = [
  'Awww Yeah', 'WooHoo', 'Awesome', 'Right on', 'Nice',
  'Good choice', 'Sweet', 'Way to go', 'High Five'
]

function randomSuccessMessage() {
  const randomIndex = randBetween(0, SUCCESS_MESSAGES.length - 1)
  return SUCCESS_MESSAGES[randomIndex] + '!'
}

function isExternalUrl(str) {
  return EXTERNAL_URL_REGEXP.test(str)
}

/**
 * Converts parts of texts to HTML link tags.
 * Following text parts are searched and replaced with their HTML format:
 * - @username
 * - #hashtag
 * - www.link-to-something.com/path
 * - !:md5 (mix hashes)
 *
 * To skip any of above, use skip options:
 * <pre>
 * 'url'
 * 'username'
 * 'hashtag'
 * 'mixurl'
 * </pre>
 * @param {string} str
 * @param {string[]} skip
 * @returns {string}
 */
function linkify(input, skip = []) {
  let output = input

  if (skip.indexOf('username') === -1) {
    output = output.replace(/(^|\B)@([\w_\/-]+)/g, function (_, start, username) {
      const href = `/${username}`
      return start + `<a class="linked-username" href="${href}" data-navigate="${href}">@${username}</a>`
    })
  }

  if (skip.indexOf('hashtag') === -1) {
    output = output.replace(/(^|\s)#([\S]+)/g, function (_, start, topic) {
      const href = `/search/${encodeURIComponent(topic)}?context_id=hashtag`
      return start + `<a class="linked-topic" href="${href}" data-navigate="${href}">#${topic}</a>`
    })
  }

  if (skip.indexOf('url') === -1) {
    output = output.replace(/(^|\s)(?:www\.|https?:\/\/)([\.\-\w]+)(\S*)(\s|$)/g, function (_, start, base, path, last) {
      return start + '<a class="linked-url" target="_blank" rel="nofollow noopener" href="http://' + base + path + '">' + base + path + '</a>' + last
    })
  }

  if (skip.indexOf('mixurl') === -1) {
    output = output.replace(/(^|\s)!(\w{7}):([^:]+):/g, function (_, start, hash, text) {
      const cleanText = nameUtils.displayText(text)
      const href = `/!${hash}:${nameUtils.prettyUrl(cleanText)}`
      return start + `<a class="linked-article" data-navigate="${href}" href="${href}">${cleanText}</a>`
    })
  }

  return output
}

function randBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

function formatPhone(n) {
  if (!n || n.length != 10) {
    return n || ''
  }
  return '(' + n.slice(0, 3) + ') ' + n.slice(3, 6) + '-' + n.slice(6, 10)
}

function fuzzyMatcherRegexp(string) {
  // Insert `[\S\s]*` between each character
  // Correctly handles problematic RegExp characters
  const matcherInput = _.escapeRegExp(string)
  .replace(/(\\.|.)/g, '$1[\\S\\s]*')
  return new RegExp('^' + matcherInput, 'i')
}

function stringToBool(obj) {
  _.each(obj, (value, key) => {
    if (_.isObject(value)) {
      stringToBool(value)
    } else if (value === 'true') {
      obj[key] = true
    } else if (value === 'false') {
      obj[key] = false
    }
  })
}

/**
 * Returns the given url without protocol.
 *
 * @param {String} url
 */
function urlWithoutProtocol(url) {
  return url.replace(/^(https?:|)\/\//ig,'')
}

// DEFAULT_USER_* constants are placed here for readability
const DEFAULT_USER_SETTINGS = {
  'color_theme': 'light'
, 'live_feed': false
, 'hints': true
, 'auto_follow_social': false
, 'notifications': {
    'sound_notification': false
  , 'email': {
      'mention_notification': false
    , 'subsequent_comment': false
    , 'url_share_comment': false
    , 'follow_notification': false
    , 'connected_friend_joins': false
    , 'friend_remixed': false
    , 'broadcast': false
    , 'shared_with_you': false
    , 'weekly_digest': false
    }
  , 'sms': {
      'mention_notification': false
    , 'subsequent_comment': false
    , 'url_share_comment': false
    , 'follow_notification': false
    , 'connected_friend_joins': false
    , 'friend_remixed': false
    , 'shared_with_you': false
    }
  , 'sns': {
      'mention_notification': false
    , 'subsequent_comment': false
    , 'url_share_comment': false
    , 'follow_notification': false
    , 'connected_friend_joins': false
    , 'friend_remixed': false
    , 'shared_with_you': false
    }
  }
}

const DEFAULT_CONFIRMED_USER_SETTINGS = {
  'color_theme': 'light'
, 'live_feed': false
, 'hints': true
, 'auto_follow_social': true
, 'notifications': {
    'sound_notification': false
  , 'email': {
      'mention_notification': true
    , 'subsequent_comment': true
    , 'url_share_comment': true
    , 'follow_notification': true
    , 'connected_friend_joins': true
    , 'friend_remixed': true
    , 'shared_with_you': true
    , 'broadcast': true
    , 'weekly_digest': true
    }
  , 'sms': {
      'mention_notification': false
    , 'subsequent_comment': false
    , 'url_share_comment': false
    , 'follow_notification': false
    , 'connected_friend_joins': true
    , 'friend_remixed': false
    , 'shared_with_you': false
    }
  , 'sns': {
      'mention_notification': true
    , 'subsequent_comment': true
    , 'url_share_comment': true
    , 'follow_notification': true
    , 'connected_friend_joins': true
    , 'friend_remixed': true
    , 'shared_with_you': true
    }
  }
}

module.exports = {
  DEFAULT_USER_SETTINGS,
  DEFAULT_CONFIRMED_USER_SETTINGS,
  randomSuccessMessage,
  isExternalUrl,
  linkify,
  randBetween,
  formatPhone,
  fuzzyMatcherRegexp,
  stringToBool,
  urlWithoutProtocol
}
